import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import { getAccountDetailsService, OsnAccountDetailsModel } from "@WhiteCap/Services/OsnAccountDetailsService";

export interface GetAccountDetailsParameter {
    searchText: string;
}

type HandlerType = ApiHandlerDiscreteParameter<GetAccountDetailsParameter, {}, ServiceResult<OsnAccountDetailsModel>>;

export const DispatchBeginLoad: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/AccountSearch/Begin",
    });
};

export const GetAccountDetails: HandlerType = async props => {
    const { searchText } = props.parameter;
    const apiResponse = await getAccountDetailsService(searchText);
    if (apiResponse.successful && apiResponse.result) {
        props.apiResult = {
            successful: true,
            result: apiResponse.result,
        };
        return;
    }

    props.apiResult = {
        successful: false,
        errorMessage: apiResponse.errorMessage || translate("Customer not found!"),
    };
};

export const HandleResponse: HandlerType = props => {
    const { apiResult } = props;

    if (apiResult?.successful && apiResult.result) {
        props.dispatch({
            type: "Custom/SubscriptionDashboard/AccountSearch/Success",
            accountDetails: apiResult.result,
        });

        props.dispatch({
            type: "Custom/SubscriptionDashboard/SetCurrentSubscriptionCustomerId",
            value: apiResult.result.id,
        });

        props.dispatch({
            type: "Custom/SubscriptionDashboard/ToggleAccountSelectionModal",
            value: false,
        });

        props.dispatch({
            type: "Custom/SubscriptionDashboard/ModifyOsnTypeSelectionModalOpenState",
            value: true,
        });
    } else if (apiResult && !apiResult.successful) {
        props.dispatch({
            type: "Custom/SubscriptionDashboard/AccountSearch/Failed",
            errorMessage: apiResult.errorMessage || translate("Error searching account. Please try again."),
        });
    }
};

export const DispatchCompleteLoadAccountDetailsData: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/AccountSearch/Complete",
    });
};

export const chain = [DispatchBeginLoad, GetAccountDetails, HandleResponse, DispatchCompleteLoadAccountDetailsData];

const osnGetAccountDetails = createHandlerChainRunner(chain, "OsnGetAccountDetails");
export default osnGetAccountDetails;
